export const languages = [
    { code: "en", name: "English" },
    { code: "fr", name: "French" },
    { code: "ht", name: "Creole" },
    { code: "so", name: "Somali" },
    { code: "zh", name: "Mandarin" },
    {
        code: "ar",
        name: "Arabic",
        dialects: [
            { code: "ar-ma", name: "Morocco" },
            { code: "ar-qa", name: "Qatar" },
            { code: "ar-lb", name: "Lebanese" },
            { code: "ar-sy", name: "Syrian" },
        ]
    },
    { code: "ru", name: "Russian" },
    { code: "es", name: "Spanish" },
    { code: "sw", name: "Swahili" },
    { code: "ti", name: "Tigrinya (Eritrean)" },
    { code: "fa", name: "Farsi" },
    { code: "vi", name: "Vietnamese" },
    { code: "ur", name: "Urdu" },
    { code: "tr", name: "Turkish" },
];
